var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"TextParser"},[_c('div',{staticClass:"animate__animated animate__fadeIn",domProps:{"innerHTML":_vm._s(_vm.decodeData(_vm.content))}})])}
var staticRenderFns = []

export { render, staticRenderFns }